export const SET_SELECTED_FEED_FILTER = 'SET_SELECTED_FEED_FILTER';
export const SET_FEED_FILTER_BY_COURSE_PROGRESS =
  'SET_FEED_FILTER_BY_COURSE_PROGRESS';
export const RESET_FEED_FILTER_BY_COURSE_PROGRESS =
  'RESET_FEED_FILTER_BY_COURSE_PROGRESS';
export const CLEAR_LAST_ACCESSED_COURSE = 'CLEAR_LAST_ACCESSED_COURSE';
